import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { thumbnailPlaceholder } from '../helpers/Files';

const CollectionPreviewFile = ({
  file,
  canUserRemove,
  handleRemoveFile,
}) => {
  const intl = useIntl();

  const fileTo = {
    pathname: `/files/${file.uuid}`,
    state: {
      modal: true,
      fromCollectionSidebar: true,
    },
  };

  return (
    <li className="collection-preview-gallery-item">
      <Link to={fileTo}>
        <img src={file.urls?.thumbnailx2 || thumbnailPlaceholder} alt="" />
      </Link>
      {canUserRemove && (
        <div className="collection-preview-file-remove">
          <Link
            to="#remove"
            className="remove-button"
            title={intl.formatMessage({ defaultMessage: 'Remove' })}
            onClick={(e) => {
              e.preventDefault();
              handleRemoveFile(file.uuid);
            }}
          >
            <i className="fas fa-times-circle" />
          </Link>
        </div>
      )}
    </li>
  );
};

CollectionPreviewFile.propTypes = {
  file: PropTypes.object.isRequired,
  canUserRemove: PropTypes.bool.isRequired,
  handleRemoveFile: PropTypes.func.isRequired,
};

export default CollectionPreviewFile;
